import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import RentAffordabilityCalculator from './RentAffordabilityCalculator.js';
import { isEditor } from '../../utils/isEditor.js';

var RentAffordabilityCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$monthlyNetInco = attrs.monthlyNetIncome,
      monthlyNetIncome = _attrs$monthlyNetInco === void 0 ? '8700' : _attrs$monthlyNetInco,
      _attrs$monthlyDebts = attrs.monthlyDebts,
      monthlyDebts = _attrs$monthlyDebts === void 0 ? '0' : _attrs$monthlyDebts,
      _attrs$monthlySavings = attrs.monthlySavings,
      monthlySavings = _attrs$monthlySavings === void 0 ? '0' : _attrs$monthlySavings,
      _attrs$monthlyExpense = attrs.monthlyExpenses,
      monthlyExpenses = _attrs$monthlyExpense === void 0 ? '0' : _attrs$monthlyExpense;
    var defaultValues = {
      monthlyNetIncome: monthlyNetIncome,
      monthlyDebts: monthlyDebts,
      monthlySavings: monthlySavings,
      monthlyExpenses: monthlyExpenses
    };
    return /*#__PURE__*/React.createElement(RentAffordabilityCalculator
    // So editor reloads when values change
    , _extends({
      key: isEditor() ? JSON.stringify(defaultValues) : undefined
    }, defaultValues));
  },
  metadata: {
    name: 'constellation/rent-affordability-calculator',
    title: 'Rent Affordability Calculator',
    description: 'Calculate your rent',
    icon: 'calculator',
    keywords: ['rent', 'calculator', 'affordability'],
    category: 'more',
    attributes: {
      monthlyNetIncome: {
        type: 'string',
        default: '8700',
        label: 'Default Monthly Net Income',
        control: 'text'
      },
      monthlyDebts: {
        type: 'string',
        default: '0',
        label: 'Default Monthly Debts',
        control: 'text'
      },
      monthlySavings: {
        type: 'string',
        default: '0',
        label: 'Default Monthly Savings',
        control: 'text'
      },
      monthlyExpenses: {
        type: 'string',
        default: '0',
        label: 'Default Monthly Expenses',
        control: 'text'
      }
    }
  }
};

export { RentAffordabilityCalculatorBlock as default };
